var map = {
	"./art.png": "eaae",
	"./book.png": "5275",
	"./car.png": "1568",
	"./foundation-certificate.png": "a2ec",
	"./furniture.png": "aa28",
	"./intangible_digital-asset.png": "f405",
	"./jewel.png": "75da",
	"./other-type.png": "6d2d",
	"./precious-metal.png": "84b4",
	"./watch.png": "b0d9",
	"./wine.png": "b9dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ba0";